import { Injectable } from '@angular/core';
import { TeamReportServiceService } from '../team-report/team-report-service.service';

export interface IRosterModalHost {
  teams: any[];
  selectedRosterMembers: any[];
  selectAllRoaster(checked: boolean): void;
}

@Injectable()
export class RosterModalService {

  constructor(private teamReportService: TeamReportServiceService) {}

  // ── Add-team / invite popup ──
  addTeamPopup: boolean = false;
  teamPopup: boolean = false;
  invitePopup: boolean = false;
  showTeamModal: boolean = false;

  // ── Delete / remove popup ──
  showRosterDelMem: boolean = false;
  showRosterAddMemPopup: boolean = false;
  showRosterEditMemPopup: boolean = false;

  // ── PDF popup ──
  openPdfPopup: boolean = false;

  // ── Team create / edit state ──
  popupType: string = 'team';
  updatedTeamId: string = '';
  prevTeamName: string = '';
  temp: any;
  teamWizard: any = false;
  addPopupSaveBtnTxt: string = 'Add Members';
  addToTeamBtn: boolean = false;
  createNewTeamBtn: boolean = false;

  // ── Invitation ──
  invite: boolean = false;
  invitationList: any;
  selectedInvitation: string = 'Select Invitation';
  inviteTeamId: any;

  // ── Edit / remove member state ──
  editRosterMemDetails: any;
  membersDetails4NewTeam: any;

  // ── Remove state ──
  removeRosterMemType: number = 0;
  removeRosterMemDetails: any;
  remvoeTeamOrMem: string = 'member';
  removeTeamId: any;
  removeTeamIndex: any;

  // ── Close changes guard ──
  checkChanges: number = -1;

  // ── open add new team popup ──────────────────────────────────────────────
  open(type: string, teamId: string = '', createTeamBtn: boolean = false): void {
    this.createNewTeamBtn = createTeamBtn;
    this.popupType = type;
    this.updatedTeamId = teamId;
    this.showTeamModal = !!type;
  }

  // ── open / close team rename popup ──────────────────────────────────────
  openCloseTeamPopup(open: boolean = false, teamId: string = '', teamName: string = '', teams: any[] = []): void {
    this.teamPopup = open;
    this.updatedTeamId = teamId;
    if (open) {
      this.temp = teamName;
    } else {
      teams.forEach(team => {
        if (this.updatedTeamId === team.id) {
          team.name = this.temp;
        }
      });
    }
  }

  // ── open add-to-team popup ───────────────────────────────────────────────
  additionalTeamPopup(memberDetail: any = null, invitepop: boolean = false, host: IRosterModalHost): void {
    if (invitepop) {
      this.addToTeamBtn = true;
    } else {
      host.selectAllRoaster(false);
      this.addToTeamBtn = false;
    }
    this.invitePopup = invitepop;
    this.membersDetails4NewTeam = memberDetail;
    document.querySelector('body').classList.add('oh');
    this.addTeamPopup = true;
  }

  // ── close add-to-team popup ──────────────────────────────────────────────
  additionalTeamPopupClose(checkChangesPopup: boolean = true, host: IRosterModalHost): void {
    document.querySelector('body').classList.remove('oh');
    if (!checkChangesPopup) {
      this.checkChanges = -1;
    }
    if (this.checkChanges === 0) {
      this.checkChanges = 1;
    } else {
      this.addTeamPopup = false;
      this.membersDetails4NewTeam = null;
      this.invite = false;
      this.inviteTeamId = null;
      host.teams.forEach(team => { team.checked = false; });
      host.selectedRosterMembers = [];
    }
    host.selectAllRoaster(false);
  }

  // ── open add-member popup ────────────────────────────────────────────────
  rosterAddMember(): void {
    this.removeRosterMemType = 0;
    setTimeout(() => { this.showRosterAddMemPopup = true; }, 100);
  }

  // ── set edit member details ──────────────────────────────────────────────
  editRosterMem(record: any): void {
    this.showRosterEditMemPopup = true;
    this.editRosterMemDetails = record;
  }

  // ── set remove member state ──────────────────────────────────────────────
  removeRosterMem(record: any = '', oneOrMulti: number = 0, type: string = 'member', index: any = undefined): void {
    this.remvoeTeamOrMem = type;
    this.removeRosterMemType = oneOrMulti;
    this.removeRosterMemDetails = record;
    this.teamReportService.rosterName.next(
      record?.default_identity?.first_name
        ? record?.default_identity?.first_name
        : record?.default_profile?.first_name
        ? record?.default_profile?.first_name
        : 'No name'
    );
    if (type === 'team') {
      this.removeTeamId = record.id;
      this.removeTeamIndex = index;
    }
    if (oneOrMulti === 1) {
      this.showRosterAddMemPopup = true;
    } else {
      this.showRosterDelMem = true;
    }
  }
}
